'use client';

import { trackConversion } from '../../../../utils/meta/trackConversion';

export interface MetaTrackingConfig {
  enabled: boolean;
  eventName?: string;
  customData?: Array<{ key?: string; value?: string }>;
}

function extractEmail(values: Record<string, unknown>): string | undefined {
  return Object.values(values).find(
    (v): v is string => typeof v === 'string' && v.includes('@'),
  );
}

function buildCustomData(
  items: Array<{ key?: string; value?: string }>,
): Record<string, string> {
  return items.reduce<Record<string, string>>((acc, { key, value }) => {
    if (key && value) acc[key] = value;
    return acc;
  }, {});
}

export function fireMetaConversion(
  values: Record<string, unknown>,
  config: MetaTrackingConfig | undefined,
): void {
  if (!config?.enabled || !config.eventName) return;

  void trackConversion({
    eventName: config.eventName,
    email: extractEmail(values),
    customData: config.customData ? buildCustomData(config.customData) : undefined,
  });
}
